export default {
  title: 'צפייה באסמכתא',
  details: {
    paymentProofNumber: 'מספר אסמכתא',
    paymentDate: 'תאריך הפקדה',
    value: 'סכום',
    associatedAgents: 'סוכנים',
    comments: 'הערות',
  },
};
